import React, { useState } from 'react';
import { Button } from '@chakra-ui/react';
// import { BiShare } from 'react-icons/bi';
import { BsFillShareFill,BsShare } from 'react-icons/bs';

const ShareButton = ({ blog, handleShare }) => {
  const [isHovering, setIsHovering] = useState(false);

  const handleMouseEnter = () => {
    setIsHovering(true);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
  };

  return (
    <Button
      flex="1"
      variant="ghost"
      color="whiteAlpha"
      onClick={() => handleShare(blog)}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {isHovering ? <BsFillShareFill /> : <BsShare />}
      <span style={{ marginLeft: '0.5rem' }}>Share</span>
    </Button>
  );
};

export default ShareButton;
